import { Avatar, styled } from '@mui/material';

const Text = styled('span')(({ theme,size,radius,fontSize ,bg}) => ({
  height: size, width: size, borderRadius:radius, background: bg, fontSize:fontSize, textAlign:'center', display:'flex', justifyContent:'center', alignItems: 'center', color:"#FFF"
}));

const StyledAvatar = styled(Avatar)(({ theme,size,radius,fontSize, bg }) => ({
  height: size, width: size, borderRadius:radius, background: bg,display:"flex" 
}));

const SAvatar = ({ src, url = null, name = null , radius, size= 40, ...props }) => {

  if( !src && url ) 
    src = url;
  
  let brRds = radius || size;
  let colors = ["#ec4899","#d946ef","#10b981","#ef4444","#f97316","#84cc16","#f59e0b","#22c55e","#737373","#0ea5e9"];
  let bg ="#eee";

  if( !src && name ){
      let ltrs = [], _name = name.toString().trim().toUpperCase();
      if( _name !== ''){
          let nltr = (_name.charCodeAt(0)+_name.length) % colors.length;
          _name = _name.includes(' ') ? _name.split(' ') : [_name];
          _name.map(n=>{
              if( n.trim() !=='' && ltrs.length < 2)
                  ltrs.push(Array.from(n)[0]);
              return n;
          });
        
          bg = colors[nltr] || "#33B0F2";
          let fsize = Math.floor(23*parseFloat(size)/50);
          size = size.toString().includes('px') ? size : `${size}px`;
          brRds = brRds.toString().includes('px') ? brRds : `${brRds}px`;
          
          return <Text size={size} radius={''+brRds} bg={bg} fontSize={fsize+'px'} {...props}>{ltrs.join('')}</Text>;
      }
  }
  
  return <StyledAvatar src={src} radius={''+brRds} size={size+'px'} {...props}/>
};

export default SAvatar;
